/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

import "./FieldActionButton.scss";
import { ButtonBase, Icon } from "../../core";

export interface IFieldActionButtonProps {
	className?: string;
	iconName?: string;
	disabled?: boolean;
	selected?: boolean;
	onClick?: React.MouseEventHandler;
	tooltip?: string;
}

export const FieldActionButton = React.forwardRef<HTMLButtonElement, IFieldActionButtonProps>(
	({ className, iconName, disabled, selected, onClick, tooltip }, ref) => {
		const baseClass = BEM("edt-field-action-button", null, {
			selected
		});

		if (className) {
			baseClass.add(className);
		}

		return (
			<ButtonBase
				className={baseClass.toClassName()}
				onClick={onClick}
				disabled={disabled}
				ref={ref}
				title={tooltip}
			>
				<Icon name={iconName} className={baseClass.element("icon").toClassName()} />
			</ButtonBase>
		);
	}
);
